import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

// Menu item type
interface MenuItem {
	key: string;
	label: string;
	icon: React.ReactNode;
	route: string;
	children?: MenuItem[];
}

interface SidebarMenuItemProps {
	item: MenuItem;
	level?: number;
	isExpanded: boolean;
	isActive: boolean;
	hasActiveChild: boolean;
	onClick: () => void;
	toggleMenu: (key: string) => void;
	renderChildren?: (children: MenuItem[], parentKey: string) => React.ReactNode;
}

const SidebarMenuItem: React.FC<SidebarMenuItemProps> = ({
	item,
	level = 0,
	isExpanded,
	isActive,
	hasActiveChild,
	onClick,
	// toggleMenu,
	renderChildren,
}) => {
	const hasChildren = item.children && item.children.length > 0;

	// Style for submenu children
	const childBase =
		"flex items-center gap-3 px-3 py-2.5 font-sans whitespace-nowrap transition focus:outline-none ml-6 w-[13rem]";
	const childInactive = "bg-white text-gray-500 rounded-full font-medium";
	const childActive = "sidebar-child--active";

	const parentBase =
		"relative flex items-center gap-3 px-4 py-3 font-sans whitespace-nowrap w-full transition focus:outline-none rounded-[10px] ml-[2px]";
	const parentActive = "bg-[#066235]/[0.03] text-[#066235] font-semibold";
	const parentInactive = "bg-white text-gray-700 hover:bg-gray-100";

	return (
		<li key={item.key}>
			<div className="relative">
				{level === 0 && (isActive || hasActiveChild) && (
					<span className="absolute left-1 top-1/2 -translate-y-1/2 h-[50%] w-[3px] bg-[#066235] rounded-sm" />
				)}
				<button
					type="button"
					onClick={onClick}
					className={
						level > 0
							? `${childBase} ${isActive ? childActive : childInactive}`
							: `ml-3 ${parentBase} ${isActive || hasActiveChild ? parentActive : parentInactive}`
					}
					style={level > 0 ? { marginBottom: "0.5rem" } : {}}>
					<span className="flex items-center">{item?.icon}</span>
					<span className="flex-1 text-left">{item?.label}</span>
					{hasChildren && (isExpanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />)}
				</button>
			</div>
			{hasChildren && isExpanded && renderChildren && (
				<ul className="space-y-2 mt-2">{renderChildren(item.children || [], item.key)}</ul>
			)}
		</li>
	);
};

export default SidebarMenuItem;
